import { httpDelete, httpGet, httpPatch, httpPost } from "../connection";

export async function getCaseStatuses() {
  return await httpGet(`/case-status`);
}

export async function createCaseStatus(values: { status_name: string }) {
  return await httpPost(`/case-status`, values);
}

export async function updateCaseStatus(
  case_status_id: number,
  values: { status_name?: string } = {}
) {
  return await httpPatch(`/case-status/${case_status_id}`, values);
}

export async function deleteCaseStatus(
  id: number,
  options = { replace: null }
) {
  if (options.replace == null) return await httpDelete(`/case-status/${id}`);
  else if (options.replace != null)
    return await httpDelete(`/case-status/${id}?replace=${options.replace}`);
}

const CaseStatusApi = {
  getCaseStatuses,
  createCaseStatus,
  updateCaseStatus,
  deleteCaseStatus,
};

export default CaseStatusApi;
